export default {
  plano: null,
  faturas: []
}
